<template>
    <div class="Field__Component">
        <div><slot>{{value && value.Name}}</slot></div>
    </div>
</template>

<script>
export default {
    name: 'FieldVehicleType',
    props: ['value'],
};
</script>

<style>

</style>
